export default __webpack_public_path__ + "static/media/average.11f9de17.svg";